module.exports = __webpack_public_path__ + "static/media/3. Atrapada, Mixta en tela, 100 x 100 cm, 2018 copy.864ab90f.png";